import { gql } from "@apollo/client"

export const SAVE_PLATFORM_SETTINGS = gql`
  mutation savePlatformSettings($data: SavePlatformSettingsInput) {
    platformSettings {
      savePlatformSettings(data: $data)
    }
  }
`
